import { footerLinks, heroMeta } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-200 border-t border-background-300/70">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-black text-xl">
                看
              </span>
              <span className="font-heading font-black text-2xl text-foreground-950">看料91</span>
            </div>
            <p className="mt-5 text-sm text-foreground-600 leading-relaxed max-w-md">
              看料91热门、爆款内容实时盘点，高能焦点一网打尽。这里聚合热议话题与火料，帮你快速判断当前最值得关注的看点。
            </p>
            <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 border border-background-300/70 text-xs font-medium text-foreground-700">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-dot" />
              实时更新中 · {heroMeta.date}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerLinks.map(([title, links]) => (
              <div key={title as string}>
                <h4 className="font-heading font-bold text-foreground-950 text-sm md:text-base">
                  {title as string}
                </h4>
                <ul className="mt-4 space-y-3">
                  {(links as string[]).map((link) => (
                    <li key={link}>
                      <a
                        href="#topics"
                        className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-300/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 leading-relaxed">
            © 2026 看料91 · 本站为内容聚合展示页面，示例内容仅用于版式演示。
          </p>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <a href="#top" className="hover:text-primary-700 transition-colors">
              站内导航
            </a>
            <a href="#board" className="hover:text-primary-700 transition-colors">
              热度榜单
            </a>
            <a href="#topics" className="hover:text-primary-700 transition-colors">
              话题聚合
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}